export default function Services() {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'Collision Repair',
      description: 'Expert repair services for accident damage and collision repairs. We restore your vehicle to pre-accident condition.',
      features: ['Frame straightening', 'Body panel replacement', 'Structural repairs']
    },
    {
      icon: 'ri-contrast-drop-2-line',
      title: 'Auto Painting',
      description: 'Custom paint jobs and color matching services. Professional finish with state-of-the-art paint booth technology.',
      features: ['Color matching', 'Custom finishes', 'Clear coat protection']
    },
    {
      icon: 'ri-hammer-line',
      title: 'Dent Removal',
      description: 'Paintless dent removal and traditional dent repair. Quick and affordable solutions for minor to major dents.',
      features: ['Paintless dent repair', 'Hail damage repair', 'Door ding removal']
    },
    {
      icon: 'ri-steering-2-line',
      title: 'Bumper Repair',
      description: 'Professional bumper repair and replacement services. Fast turnaround for front and rear bumper damage.',
      features: ['Plastic welding', 'Bumper refinishing', 'Sensor recalibration']
    },
    {
      icon: 'ri-file-shield-2-line',
      title: 'Insurance Claims',
      description: 'Complete assistance with insurance claims process. We work directly with your insurance company.',
      features: ['Direct billing', 'Claims processing', 'Documentation support']
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Auto Restoration',
      description: 'Complete vehicle restoration services. Bring your classic or damaged vehicle back to life.',
      features: ['Classic car restoration', 'Rust repair', 'Complete overhauls']
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-amber-100 rounded-full mb-4">
            <i className="ri-tools-line text-amber-600"></i>
            <span className="text-sm text-amber-900 font-semibold">Our Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 font-['Space_Grotesk'] mb-4">
            Comprehensive Auto Body Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From minor dents to major collision repairs, we handle it all with precision and care
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl border border-gray-200 hover:border-amber-300 hover:shadow-xl transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-white rounded-xl shadow-md mb-6 group-hover:shadow-lg transition-all">
                <i className={`${service.icon} text-3xl text-amber-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 font-['Space_Grotesk']">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-amber-600 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-amber-500 to-orange-600 text-white rounded-lg shadow-lg hover:shadow-xl transition-all cursor-pointer">
            <span className="text-sm font-semibold whitespace-nowrap">Get Your Free Estimate Today</span>
            <i className="ri-arrow-right-line"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
